import { useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import RegistrantsPage from "./pages/RegistrantsPage";
import RegistrantDetailPage from "./pages/RegistrantDetailPage";
import RegistrantFormPage from "./pages/RegistrantFormPage";
import CompletionFormPage from "./pages/CompletionFormPage";
import PrimaryEvidenceFormPage from "./pages/PrimaryEvidenceFormPage";
import CertTypesPage from "./pages/CertTypesPage";
import DocsPage from "./pages/DocsPage";
import { ApiLogEntry } from "./lib/types";
import { registerLogSink } from "./lib/apiClient";

const MAX_LOG_ENTRIES = 200;

export default function App() {
  const [log, setLog] = useState<ApiLogEntry[]>([]);

  useEffect(() => {
    registerLogSink(entry => {
      setLog(prev => [entry, ...prev].slice(0, MAX_LOG_ENTRIES));
    });
  }, []);

  return (
    <Layout log={log} onClearLog={() => setLog([])}>
      <Routes>
        <Route path="/" element={<Navigate to="/registrants" replace />} />
        <Route path="/registrants" element={<RegistrantsPage />} />
        <Route path="/registrants/new" element={<RegistrantFormPage />} />
        <Route path="/registrants/:pin" element={<RegistrantDetailPage />} />
        <Route path="/registrants/:pin/completions/new" element={<CompletionFormPage mode="create" />} />
        <Route path="/completions/:id/edit" element={<CompletionFormPage mode="edit" />} />
        <Route path="/registrants/:pin/primary-evidence/new" element={<PrimaryEvidenceFormPage mode="create" />} />
        <Route path="/primary-evidence/:id/edit" element={<PrimaryEvidenceFormPage mode="edit" />} />
        <Route path="/cert-types" element={<CertTypesPage />} />
        <Route path="/docs" element={<DocsPage />} />
      </Routes>
    </Layout>
  );
}
